import { useMemo } from 'react';
import { useNode } from '@craftjs/core';
import {
  FormDropdownInputComponent,
  FormDropdownInputProps,
} from 'src/features/generalForms/builder/types/DropdownInput';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import {
  TitlePanel,
  AnswersPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
  DropdownPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { AppDropdownField } from 'src/features/generalForms/uikit/fields/dropdown/dropDownField';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';

export const FormDropDownInput: FormDropdownInputComponent = (props) => {
  const {
    actions: { setProp },
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const validationResult = useDataKeyValidation();

  const options: DropdownOption[] = useMemo(
    () =>
      props.options?.map((option) => ({
        key: option.key,
        text: option.value,
      })) ?? [],
    [props.options],
  );

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppDropdownField<DropdownOption>
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        isRequired={!props.isOptional}
        placeholder={props.placeholder}
        suggestion={props.suggestion}
        disabled={props.disabled}
        options={options}
        value={options.find((o) => o.key === props.defaultValue)}
        onChange={(e) =>
          setProp((p: FormDropdownInputProps) => {
            p.defaultValue = e?.key || undefined;
          }, 500)
        }
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormDropdownInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel sections={['NoAnswerScore']} />
    <DropdownPanel />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormDropDownInput.craft = {
  displayName: 'Dropdown',
  rules: { canDrag: () => true },
  related: { settings: FormDropdownInputSettings },
};
